import React from "react";

export const Stats = (props) => {
    return (
        <div id="stats" style={{
            background: "#111",
            padding: "40px 0",
            textAlign: "center"
        }}>
            <div className="container">
                <div className="row">
                    {props.data
                        ? props.data.map((d, i) => (
                            <div key={i} className="col-xs-12 col-sm-4" style={{ marginBottom: "20px" }}>
                                <h2 style={{
                                    color: "#f4033f",
                                    fontSize: "48px",
                                    fontWeight: "800",
                                    margin: "0"
                                }}>
                                    {d.value}
                                </h2>
                                <p style={{
                                    color: "#fff",
                                    fontSize: "16px",
                                    textTransform: "uppercase",
                                    letterSpacing: "2px",
                                    margin: "8px 0 0"
                                }}>
                                    {d.label}
                                </p>
                            </div>
                        ))
                        : "Loading..."}
                </div>
            </div>
        </div>
    );
};